import {
  getStoredConfiguration,
  saveStoredConfiguration,
} from '@/api/WhisApi/configuration/configuration.storage';
import config from '@/config/config';
import { checkNetworkConnectivity } from '@/utils/network/network.utils';
import { configurationApi } from '@api/WhisApi/configuration/configuration.api';
import { ConfigurationResponseDto } from '@api/WhisApi/configuration/configuration.types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

const configurationKeys = {
  all: ['configuration'],
};

export function useGetConfiguration(): UseQueryResult<
  ConfigurationResponseDto,
  Error
> {
  return useQuery({
    queryKey: [configurationKeys.all],
    networkMode: 'always',
    retry: false,
    queryFn: async () => {
      if (__DEV__) {
        return {
          azureAdConfiguration: {
            issuer: config.microsoftAuth.tenantId ?? '',
            clientId: config.microsoftAuth.clientId ?? '',
            backendScope: config.microsoftAuth.backendScope,
          },
        };
      }

      try {
        const remoteConfiguration = await configurationApi.get();
        void saveStoredConfiguration(remoteConfiguration);
        return remoteConfiguration;
      } catch (error) {
        const isOnline = await checkNetworkConnectivity();
        if (isOnline) {
          throw error;
        }

        const storedConfiguration = await getStoredConfiguration();
        if (storedConfiguration) {
          return storedConfiguration;
        }

        throw error;
      }
    },
  });
}
